/**
 * Userのステータスを変更するAction
 */
import { userStatus } from './status';
import { postFollowing, postUnfollowing } from './postFollowUnfollow';

export class UserActions {
  constructor (user) {
    this.user = user;
  }

  handleFollowCompany (companyId) {
    return postFollowing(companyId).then((res) => {
      this.updateStatus(userStatus.loginedAndFollowing);
    });
  }

  handleUnfollowCompany (companyId) {
    return postUnfollowing(companyId).then((res) => {
      this.updateStatus(userStatus.loginedNotFollowing);
    });
  }

  followCompany (companyId) {
    return this.handleFollowCompany(companyId);
  }

  unfollowCompany (companyId) {
    return this.handleUnfollowCompany(companyId);
  }

  updateStatus (status) {
    this.user.status = status;
  }
}
